/*
 * @Author: wangshengqiang
 * @Date: 2021-07-07 11:14:54
 * @LastEditTime: 2021-07-08 14:24:39
 * @LastEditors: wangshengqiang
 * @Description:
 */
import React from 'react';
import classnames from 'classnames';
import { runEnv } from '@/utils/runEnv.js';
import { isPreviewMode, isSimulateMode } from '@/utils/tool';
import { useBehavior } from '../../hooks';
const Channel = /*#__PURE__*/React.forwardRef((props = {}, ref) => {
  const {
    className,
    children,
    label,
    Render,
    attrs
  } = props;
  const cls = classnames({
    'components-channel-render': true,
    [className]: !!className
  });
  const behavior = useBehavior();
  const {
    resultChannel = '0'
  } = behavior;

  if (isPreviewMode()) {
    const num = Number(resultChannel);

    if (label === 'h5' && num !== 0) {
      return null;
    }

    if (label === '微信' && num !== 1) {
      return null;
    }
  } else if (isSimulateMode()) {
    return /*#__PURE__*/React.createElement("div", {
      className: "channel-message"
    }, "\u4E0D\u652F\u6301\u9884\u89C8");
  } else {
    if (label === 'h5' && runEnv !== 'browser') {
      return null;
    }

    if (label === '微信' && runEnv !== 'wechat') {
      return null;
    }
  }

  return /*#__PURE__*/React.createElement("div", {
    className: cls,
    ref: ref
  }, /*#__PURE__*/React.createElement(Render, {
    components: children
  }));
});
export default Channel;